import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

// One date-only picker for reminders, including inside either kind of modal.
export default class extends Controller {
    static targets = ["input"]
    static values = { maxDate: String }

    connect() {
        this.picker = flatpickr(this.inputTarget, {
            dateFormat: "Y-m-d",
            altInput: false,
            allowInput: false,
            // Preserve the site's native phone picker; Flatpickr uses only one UI.
            disableMobile: false,
            enableTime: false,
            // Keep the calendar inside the modal's focus boundary.
            static: true,
            // Closing on mousedown would move the in-flow form before its button's click.
            ignoredFocusElements: [this.element.closest(".swal2-popup, .modal") || this.inputTarget.form || this.element],
            maxDate: this.hasMaxDateValue ? this.maxDateValue : undefined,
            locale: { firstDayOfWeek: 1 },
            onChange: () => this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
        })
        if (this.picker.mobileInput) {
            const mobileInput = this.picker.mobileInput
            mobileInput.tabIndex = this.inputTarget.tabIndex
            mobileInput.setAttribute("aria-label", this.inputTarget.getAttribute("aria-label") || "Birthdate")
            mobileInput.addEventListener("click", () => {
                // Open from anywhere in the field where supported; otherwise keep native behavior.
                try { mobileInput.showPicker?.() } catch (_) { /* Native tap handling remains available. */ }
            })
        }
        this.beforeCache = () => this.destroyPicker()
        document.addEventListener("turbo:before-cache", this.beforeCache)
    }

    disconnect() {
        document.removeEventListener("turbo:before-cache", this.beforeCache)
        this.destroyPicker()
    }

    destroyPicker() {
        this.picker?.destroy()
        this.picker = null
    }
}
